import { useQueryClient } from 'react-query'

import Text from 'app/components/base/Text'
import { listingKeys } from 'app/services/Query/listing/listing.keys'

interface SearchCategoryTitleProps {
  searchCategory: string
}

const SearchCategoryTitle: RFC<SearchCategoryTitleProps> = ({
  searchCategory
}) => {
  const queryClient = useQueryClient()

  const categories = queryClient.getQueryData<Category[]>(
    listingKeys.getListingCategories()
  )

  const categoryName = categories?.find(
    ({ slug }) => slug === searchCategory
  )?.name

  return (
    <Text component="h1" variant="h2">
      {categoryName}
    </Text>
  )
}

export default SearchCategoryTitle
